import storePlugin from './store';
import routerPlugin from './router';
import * as constants from './constants';

const log = require('debug')('@mycure/vue-plugins/' + constants.NAMESPACE);

/**
 * @typedef {Object} PluginOpts
 * @property {string} namespace
 * @property {import('@mycure/sdk').CoreService} sdk
 * @property {import('vuex').Store} store
 * @property {import('./store/store').StoreOpts} storeOpts
 * @property {import('vue-router').default} router
 * @property {import('./router/router').RouterOpts} routerOpts
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {PluginOpts} [opts]
   */
  install (Vue, opts) {
    const { storeOpts, routerOpts, ...restOpts } = opts = Object.assign({ namespace: constants.NAMESPACE }, opts);
    log(`installing '${constants.NAMESPACE}' with opts'`, opts);

    // instal store module
    if (opts.store && opts.sdk) Vue.use(storePlugin, { ...restOpts, ...storeOpts });

    // install router module
    if (opts.store && opts.sdk && opts.router) Vue.use(routerPlugin, { ...restOpts, ...routerOpts });
  },
  namespace: constants.NAMESPACE
};
